import React, { useState } from "react";
import {
  Container,
  Image,
  Form,
  Toast,
  ToastContainer,
  Nav,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  ViewOffSlashIcon,
  EyeIcon,
  CheckmarkBadge04Icon,
} from "../../assets/icons";
// import logoBlack from "../../assets/images/logo/logo-dark.png";
import LoginLogo from "../../assets/images/login/shapes/login-logo.png";
import "./Styles/Login.css";
import { useDispatch} from "react-redux";
import CommonButton from "../../components/commonButton";
import CommonFormLabel from "../../components/formLabel";
import Input from "../../components/input";
import { routes } from "../../routes/PageRoutes";
import { Formik } from "formik";
import {emailLoginSchema,mobileLoginSchema} from "../../schema/ValidationSchema";
import ValidationFeedback from "../../components/validationFeedback";
import { loginUser } from "../../redux/slice/authSlice";
import useMounted from "../../hooks/useMounted";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasMounted = useMounted();

  // const { status, error } = useSelector((state) => state.auth);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("toast-success");

  const [showEyeIcon, setShowEyeIcon] = useState(false);

  const [loginType, setLoginType] = useState("email");

  const initialEmailState = {
    email: "",
    password: "",
  };

  const initialMobileState = {
    phone: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    // console.log("handleSubmit called"); // Debugging step
    if (loginType === "mobile") {
      // console.log("Mobile form submitted");
      navigate(routes.verifyOtp);
    } else if (loginType === "email") {
      const data = {email:values.email,password:values.password}
      try {
        const result = await dispatch(loginUser(data)).unwrap()
        setToastMessage(result?.message || "Login successfull!");
        setToastVariant("toast-success");
        setTimeout(() => {
          if (hasMounted) {
            navigate("/", { replace: true });
          }
        }, 1000);
      } catch (err) {
        const errorMessage = err?.message || "Failed to Login";
        setToastMessage(errorMessage);
        setToastVariant("toast-danger");
      } finally {
        setShowToast(true);
        setSubmitting(false);
      }
    }
  };

  // console.log("loginType : ", loginType);

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={5000}
          autohide
          bg={toastVariant}
          className="position-fixed top-3 end-0 me-3 shadow-none"
        >
          <Toast.Body className="d-flex align-items-center gap-1 lh-sm">
            <CheckmarkBadge04Icon
              width={18}
              height={18}
              color="#28c76f"
              strokeWidth="2"
            />
            <span className="text-capitalize">{toastMessage}</span>
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Container fluid="xxl" className="mx-auto px-4">
        <div className="d-flex align-items-center justify-content-center py-4  login-content">
          <div className="position-relative w-100 py-4 login-sub-content">
            <div className="bg-white rounded-2 p-5 common-shadow login-card">
              <h1 className="fs-5 d-flex align-content-center justify-content-center mb-4">
                <span className="text-decoration-none  d-inline-block">
                  <Image src={LoginLogo} alt="Site-Logo" />
                </span>
              </h1>
              <div className="mb-4 welcome-content">
                <h4 className="mb-1 fw-medium text-start">
                  Welcome to NPA Bank Portal
                </h4>
                <p className="text-start">
                  Login seamlessly with mobile number or email
                </p>
              </div>

              {/* Tab for login options */}
              <Nav className="d-flex justify-content-center mb-4 login-tabs">
                <Nav.Item>
                  <Nav.Link
                    eventKey="mobile"
                    className={`tab-link ${loginType === "mobile" ? "active-tab" : ""}`}
                    onClick={() => setLoginType("mobile")}
                  >
                    Mobile Number
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="email"
                    className={`tab-link ${loginType === "email" ? "active-tab" : ""}`}
                    onClick={() => setLoginType("email")}
                  >
                    Email Address
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <Formik
                initialValues={loginType === "email" ? initialEmailState : initialMobileState}
                validationSchema={loginType === "email" ? emailLoginSchema : mobileLoginSchema}
                onSubmit={handleSubmit}
              >
                {({
                  errors,
                  touched,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  values,
                  setFieldValue,
                  handleSubmit,
                }) => (
                  <>
                    {/* {console.log("values:: ", values)} */}
                    {/* {console.log("errors:: ", errors)}
                    {console.log("touched:: ", touched)} */}

                    {loginType === "mobile" ? (
                      <Form onSubmit={(e) => handleSubmit(e, "mobile")}>
                        <div className="mb-4">
                          <CommonFormLabel title="Mobile Number" />
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="+91 9898989898"
                            // onChange={handleChange}
                            className={`shadow-none`}
                            // className={`shadow-none ${touched.email && errors.email ? 'error' : 'correct'}`}
                          />
                        </div>
                        <CommonButton
                          title="Next"
                          type="submit"
                          className="w-100 btn-primary primary-shadow"
                          disabled
                        />
                      </Form>
                    ) : (
                      <Form onSubmit={(e) => handleSubmit(e, "email")}>
                        <div className="mb-4">
                          <CommonFormLabel title="Email" />
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="johndoe@gmail.com"
                            onChange={handleChange}
                            className={`shadow-none ${
                              touched.email && errors.email
                                ? "error"
                                : "correct"
                            }`}
                          />
                          {/* {touched.email &&  */}
                          {errors.email ? (
                            <ValidationFeedback title={errors.email} />
                          ) : null}
                        </div>
                        <div className="mb-4">
                          <CommonFormLabel title="Password" />
                          <div className="position-relative">
                            <Input
                              id="password"
                              name="password"
                              type={`${showEyeIcon ? "text" : "password"}`}
                              placeholder="············"
                              onChange={handleChange}
                              className={`shadow-none ${
                                touched.password && errors.password
                                  ? "error"
                                  : "correct"
                              }`}
                            />
                            <div className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer">
                              {showEyeIcon === false ? (
                                <ViewOffSlashIcon
                                  width={20}
                                  height={20}
                                  color="#444050"
                                  strokeWidth="1.5"
                                  className={
                                    touched.password && errors.password
                                      ? "error"
                                      : "correct"
                                  }
                                  onClick={() => setShowEyeIcon(true)}
                                />
                              ) : (
                                <EyeIcon
                                  width={20}
                                  height={20}
                                  color="#444050"
                                  strokeWidth="1.5"
                                  className={`${
                                    touched.password && errors.password
                                      ? "error"
                                      : "correct"
                                  }`}
                                  onClick={() => setShowEyeIcon(false)}
                                />
                              )}
                            </div>
                          </div>
                          {/* {touched.password &&  */}
                          {errors.password ? (
                            <ValidationFeedback title={errors.password} />
                          ) : null}
                        </div>
                        <div className="d-flex align-items-center justify-content-between forget-link">
                          <div className="d-flex align-items-center">
                            {/* <input type="checkbox" className="login-checkbox" />
                                <CommonFormLabel
                                title="Remember me"
                                className="mt-1 mx-2"
                            /> */}
                          </div>
                          {/* <Link
                            to={routes.forgotPasswordEmail}
                            className="text-decoration-none"
                          >
                            Forgot Password?
                          </Link> */}
                        </div>
                        <CommonButton
                          title="Login"
                          type="submit"
                          className="w-100 btn-primary primary-shadow"
                        />
                      </Form>
                    )}
                  </>
                )}
              </Formik>

              <div className="mb-4 welcome-content d-flex align-items-center justify-content-center gap-2 mt-4">
                <p>New on our platform?</p>
                <div className="register-link">
                  <Link
                    to={routes.register}
                    className="text-decoration-none register-link"
                  >
                    Create an account
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Login;
